import { createTheme, LinearProgress, ThemeProvider } from "@mui/material"

const ProgressBar = (props) => {
    const theme = createTheme({})
    return <ThemeProvider theme={theme}><LinearProgress /></ThemeProvider>
}

export default ProgressBar